import styled from 'styled-components';

export default styled.img.attrs({
  id: props => props.id || '',
  src: props => props.src || ''
})`
  position: absolute;
  top: ${props => `${props.top || 0}${props.unit || 'px'}`};
  left: ${props => `${props.left || 0}${props.unit || 'px'}`};
  height: ${props => {
    let height = props.height || 'auto';
    let unit = props.unit || 'px';
    if (height !== 'auto') {
      height += unit;
    }
    return height;
  }};
  width: ${props => {
    let width = props.width || 'auto';
    let unit = props.unit || 'px';
    if (width !== 'auto') {
      width += unit;
    }
    return width;
  }};
`;
